// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: Arial, Helvetica, sans-serif;
}

:root {
  --primary-white: #fff;
  --primary-black: #000;
  --primary-grey: #73739a;
  --primary-blue: #6d72f6;
}

::-webkit-scrollbar {
  width: 10px;
}

::-webkit-scrollbar-thumb {
  background: linear-gradient(to bottom, #caccf5 50%, #8084ff 100%);
  border-radius: 6px;
}

::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(to bottom, #b3b5f8 50%, #5a5ff0 100%);
}

/* Header Container */
.header-container {
  width: 100%;
  margin: 0 auto;
  padding: 30px 10px;
  max-width: 1200px;
  gap: 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  z-index: 99900;
}

/* Logo Styling */
.header-logo-box img {
  width: 100%;
  max-width: 220px;
  cursor: pointer;
  transition: 0.3s linear;
}

.header-logo-box img:hover {
  transform: scale(1.1);
}

/* Navigation Links Container */
.header-links-box {
  gap: 22px;
  display: flex;
  align-items: center;
  position: relative;
}

.header-links-box a {
  gap: 3px;
  font-size: 16px;
  display: flex;
  align-items: center;
  text-decoration: none;
  transition: 0.3s linear;
  color: var(--primary-grey);
}

.header-links-box a:hover {
  color: var(--primary-blue);
}

/* Dropdown Wrapper */
.dropdown-wrapper {
  position: relative;
}

.dropdown-trigger {
  display: flex;
  align-items: center;
  gap: 3px;
  cursor: pointer;
}

/* Dropdown Icon */
.dropdown-icon {
  transition: transform 0.3s ease;
}

.dropdown-icon.rotated {
  transform: rotate(180deg);
}

/* Dropdown Content */
.dropdown-content {
  position: absolute;
  top: 100%;
  left: 0;
  text-align: left;
  min-width: 250px;
  background-color: var(--primary-white);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  padding: 8px;
  z-index: 10;
  animation: dropdownFadeIn 0.3s ease;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

/* Dropdown Animation */
@keyframes dropdownFadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Dropdown Items */
.dropdown-item {
  display: block;
  padding: 8px;
  color: var(--primary-grey);
  text-decoration: none;
  transition: background-color 0.3s ease;
  border-radius: 8px;
  font-size: 12px;
}

.active {
  display: block;
  padding: 8px;
  color: white;
  text-decoration: none;
  transition: background-color 0.3s ease;
  border-radius: 8px;
  font-size: 12px;
  background-color: #6d72f6;
}

.dropdown-item:hover {
  background-color: #f4f4f4;
  color: var(--primary-blue);
}

/* Hamburger Menu Styling */
.hamburger-menu {
  display: none;
  cursor: pointer;
  width: 30px;
  height: 25px;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}

/* Hamburger Menu Animation */
.hamburger-menu.open .line:nth-child(1) {
  transform: rotate(45deg);
  position: relative;
  top: 8px;
}

.hamburger-menu.open .line:nth-child(2) {
  opacity: 0;
}

.hamburger-menu.open .line:nth-child(3) {
  transform: rotate(-45deg);
  position: relative;
  top: -8px;
}

.line {
  width: 100%;
  height: 4px;
  background-color: var(--primary-black);
  transition: 0.3s ease;
}

/* Mobile Responsive Styles */
@media screen and (max-width: 1024px) {
  .header-links-box {
    display: none;
    flex-direction: column;
    gap: 20px;
    align-items: flex-start;
    position: absolute;
    top: 80px;
    right: 10px;
    background-color: var(--primary-white);
    padding: 20px;
    width: 300px;
    height: 90vh;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    z-index: 10;
    transition: transform 0.3s ease, opacity 0.3s ease;
    transform: translateY(-20px);
    opacity: 0;
  }

  .header-links-box.active {
    display: flex;
    transform: translateY(0);
    opacity: 1;
  }

  .hamburger-menu {
    display: flex;
  }

  .dropdown-wrapper {
    width: 100%;
  }

  .dropdown-content {
    position: relative;
    min-width: 100%;
    box-shadow: none;
    top: auto;
    left: auto;
    animation: none;
    padding: 10px 0 0 10px;
    display: flex;
    /* flex-direction: column; */

  }

  .header-links-box a {
    font-size: 18px;
    color: var(--primary-black);
  }

  .header-links-box a:hover {
    color: var(--primary-blue);
  }

  .dropdown-trigger {
    justify-content: space-between;
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Header/Header.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iEAAiE;EACjE,kBAAkB;AACpB;;AAEA;EACE,iEAAiE;AACnE;;AAEA,qBAAqB;AACrB;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,+BAA+B;AAC/B;EACE,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,QAAQ;EACR,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,sCAAsC;EACtC,wCAAwC;EACxC,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,mCAAmC;EACnC,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA,uBAAuB;AACvB;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,mBAAmB;AACnB;EACE,cAAc;EACd,YAAY;EACZ,0BAA0B;EAC1B,qBAAqB;EACrB,sCAAsC;EACtC,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,qBAAqB;EACrB,sCAAsC;EACtC,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE,wBAAwB;EACxB,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,WAAW;EACX,sCAAsC;EACtC,qBAAqB;AACvB;;AAEA,6BAA6B;AAC7B;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,uBAAuB;IACvB,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,sCAAsC;IACtC,aAAa;IACb,YAAY;IACZ,YAAY;IACZ,wCAAwC;IACxC,WAAW;IACX,kDAAkD;IAClD,4BAA4B;IAC5B,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,wBAAwB;IACxB,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,eAAe;IACf,sBAAsB;IACtB,aAAa;IACb,4BAA4B;;EAE9B;;EAEA;IACE,eAAe;IACf,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,8BAA8B;IAC9B,WAAW;EACb;AACF","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: Arial, Helvetica, sans-serif;\n}\n\n:root {\n  --primary-white: #fff;\n  --primary-black: #000;\n  --primary-grey: #73739a;\n  --primary-blue: #6d72f6;\n}\n\n::-webkit-scrollbar {\n  width: 10px;\n}\n\n::-webkit-scrollbar-thumb {\n  background: linear-gradient(to bottom, #caccf5 50%, #8084ff 100%);\n  border-radius: 6px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: linear-gradient(to bottom, #b3b5f8 50%, #5a5ff0 100%);\n}\n\n/* Header Container */\n.header-container {\n  width: 100%;\n  margin: 0 auto;\n  padding: 30px 10px;\n  max-width: 1200px;\n  gap: 14px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  position: relative;\n  z-index: 99900;\n}\n\n/* Logo Styling */\n.header-logo-box img {\n  width: 100%;\n  max-width: 220px;\n  cursor: pointer;\n  transition: 0.3s linear;\n}\n\n.header-logo-box img:hover {\n  transform: scale(1.1);\n}\n\n/* Navigation Links Container */\n.header-links-box {\n  gap: 22px;\n  display: flex;\n  align-items: center;\n  position: relative;\n}\n\n.header-links-box a {\n  gap: 3px;\n  font-size: 16px;\n  display: flex;\n  align-items: center;\n  text-decoration: none;\n  transition: 0.3s linear;\n  color: var(--primary-grey);\n}\n\n.header-links-box a:hover {\n  color: var(--primary-blue);\n}\n\n/* Dropdown Wrapper */\n.dropdown-wrapper {\n  position: relative;\n}\n\n.dropdown-trigger {\n  display: flex;\n  align-items: center;\n  gap: 3px;\n  cursor: pointer;\n}\n\n/* Dropdown Icon */\n.dropdown-icon {\n  transition: transform 0.3s ease;\n}\n\n.dropdown-icon.rotated {\n  transform: rotate(180deg);\n}\n\n/* Dropdown Content */\n.dropdown-content {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  text-align: left;\n  min-width: 250px;\n  background-color: var(--primary-white);\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  border-radius: 8px;\n  padding: 8px;\n  z-index: 10;\n  animation: dropdownFadeIn 0.3s ease;\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n}\n\n/* Dropdown Animation */\n@keyframes dropdownFadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Dropdown Items */\n.dropdown-item {\n  display: block;\n  padding: 8px;\n  color: var(--primary-grey);\n  text-decoration: none;\n  transition: background-color 0.3s ease;\n  border-radius: 8px;\n  font-size: 12px;\n}\n\n.active {\n  display: block;\n  padding: 8px;\n  color: white;\n  text-decoration: none;\n  transition: background-color 0.3s ease;\n  border-radius: 8px;\n  font-size: 12px;\n  background-color: #6d72f6;\n}\n\n.dropdown-item:hover {\n  background-color: #f4f4f4;\n  color: var(--primary-blue);\n}\n\n/* Hamburger Menu Styling */\n.hamburger-menu {\n  display: none;\n  cursor: pointer;\n  width: 30px;\n  height: 25px;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: center;\n}\n\n/* Hamburger Menu Animation */\n.hamburger-menu.open .line:nth-child(1) {\n  transform: rotate(45deg);\n  position: relative;\n  top: 8px;\n}\n\n.hamburger-menu.open .line:nth-child(2) {\n  opacity: 0;\n}\n\n.hamburger-menu.open .line:nth-child(3) {\n  transform: rotate(-45deg);\n  position: relative;\n  top: -8px;\n}\n\n.line {\n  width: 100%;\n  height: 4px;\n  background-color: var(--primary-black);\n  transition: 0.3s ease;\n}\n\n/* Mobile Responsive Styles */\n@media screen and (max-width: 1024px) {\n  .header-links-box {\n    display: none;\n    flex-direction: column;\n    gap: 20px;\n    align-items: flex-start;\n    position: absolute;\n    top: 80px;\n    right: 10px;\n    background-color: var(--primary-white);\n    padding: 20px;\n    width: 300px;\n    height: 90vh;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n    z-index: 10;\n    transition: transform 0.3s ease, opacity 0.3s ease;\n    transform: translateY(-20px);\n    opacity: 0;\n  }\n\n  .header-links-box.active {\n    display: flex;\n    transform: translateY(0);\n    opacity: 1;\n  }\n\n  .hamburger-menu {\n    display: flex;\n  }\n\n  .dropdown-wrapper {\n    width: 100%;\n  }\n\n  .dropdown-content {\n    position: relative;\n    min-width: 100%;\n    box-shadow: none;\n    top: auto;\n    left: auto;\n    animation: none;\n    padding: 10px 0 0 10px;\n    display: flex;\n    /* flex-direction: column; */\n\n  }\n\n  .header-links-box a {\n    font-size: 18px;\n    color: var(--primary-black);\n  }\n\n  .header-links-box a:hover {\n    color: var(--primary-blue);\n  }\n\n  .dropdown-trigger {\n    justify-content: space-between;\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
